import { h } from 'hyperapp';
import './index.less';
import IconButton from '~/components/icon-button/view.jsx';
export default (({
  item,
  onClick
}) => h(IconButton, {
  cls: "comment",
  icon: "comment",
  tooltip: "\u67E5\u770B\u7559\u8A00",
  badge: item.comment_count,
  onClick: onClick
}));